'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOptionLabel;
function getOptionLabel(opt, highlighted) {
  return typeof opt === 'string' || !opt ? opt : typeof opt.label === 'function' ? opt.label(opt, highlighted) : opt.label || opt.text || opt.value;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-input-enhancements/lib/utils/getOptionLabel.js
// module id = 449
// module chunks = 0